<template>
  <div class="map-root select-none">
    <div ref="map-mapview" class="map"></div>
    <div class="global-loading">
      <table>
        <tr>
          <td>
            <span class="global-loading-text" v-html="loadingText"></span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {
    MapKey: {
      required: true,
      type: String,
    },
    MapLayers: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      loadingText: "加载中...",
      mapInstance: null,
    };
  },
  methods: {
    onAreaDrawn: function (data) {
      this.$emit("onAreaDrawn", data);
    },
    onMapComplete(data) {
      this.$emit("onMapComplete", data);
    },
    oneDrawMap() {
      // 创建地图，并通过样式让地图填满窗口
      let that = this;
      var mapConfigs = {};
      this.$nextTick(function () {
        // eslint-disable-next-line no-undef
        $(function () {
          // 不传入 syscode 和 key ，或者值为空时，
          // zjumap 插件自动从 URL 地址
          // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
          // 中读取 syscode 和 key 的值。
          // eslint-disable-next-line no-undef
          $(".map").zjumap({
            syscode: "ZJMap",
            key: "DefaultMap",
            loading: ".global-loading",
            loadingText: ".global-loading-text",
            //地图配置
            // eslint-disable-next-line no-undef
            mapConfigs: $.extend(
              {},
              {
                mapStyle: "",
                togglePanelVisiable: false,
                mapLayers: "",
                reportGeo: true,
                onGotGeo: function (e) {
                  e.handled = true;
                  if (that.marker) {
                    that.marker.setPosition(
                      e.map.newPoint(e.point.lng, e.point.lat)
                    );
                  } else {
                    //that.marker = that.addMarker(e.map, e.point);
                  }
                  that.lat = e.point.lat;
                  that.lng = e.point.lng;
                },
                onAreaDrawn: function (e) {
                  that.onAreaDrawn(e.data.points);
                },
                onPolygonEditorComplete: function (e) {
                  that.onAreaDrawn(e.data);
                },
                onMapCreated: function (e) {
                  that.mapInstance = e.map;
                  e.map.clearAll();
                  that.center = e.map.config.center;
                  that.onMapComplete(that.mapInstance);
                },
              },
              mapConfigs
            ),
          });
        });
      });
    },
  },
  created() {
    console.debug("mapview created111");
  },
  mounted() {
    this.oneDrawMap();
  },

  beforeDestroy() {
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
      console.debug("mapview beforeDestroy");
    }
  },
  destroyed() {},
};
</script>

<style scoped>
.map {
  border-radius: 20px;
}
</style>